import React from 'react';
import PropTypes from 'prop-types';
import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import { ButtonWithIcon } from '@els/els-react--button';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';

function ConditionsToolbar({ selectedCount, isAllSelected, onSelectAll, onDelete, onNewSearch }) {
  return (
    <RsTableToolbar>
      <div className="rs-table-toolbar__left-controls">
        <SelectedItemsControls
          checkAllItems={onSelectAll}
          allItemsSelected={!!isAllSelected}
          currentSelectedItems={selectedCount}
          someItemsSelected={selectedCount > 0 && !isAllSelected}
        />
        <ButtonWithIcon
          data-e2e="e2e-rs-toolbar-button-delete"
          layout="vertical"
          sprite="Trash"
          type="borderless"
          size="small"
          disabled={selectedCount <= 0}
          onClick={onDelete}>
          Delete
        </ButtonWithIcon>
      </div>
      <div className="rs-table-toolbar__center-controls">
        <ButtonWithIcon
          type="link"
          sprite="DrawStructureNew"
          data-e2e="e2e-conditions-draw-reactions"
          className="rs-table-toolbar__center-controls--draw-structure e2e-conditions-draw-reactions"
          aria-label="Draw Reactions"
          onClick={onNewSearch}>
          Draw Reactions
        </ButtonWithIcon>
      </div>
    </RsTableToolbar>
  );
}

ConditionsToolbar.defaultProps = {
  selectedCount: 0,
  isAllSelected: false,
  onSelectAll: () => {},
  onDelete: () => {},
  onNewSearch: () => {},
};

ConditionsToolbar.propTypes = {
  selectedCount: PropTypes.number,
  isAllSelected: PropTypes.bool,
  onSelectAll: PropTypes.func,
  onDelete: PropTypes.func,
  onNewSearch: PropTypes.func,
};

export default ConditionsToolbar;
